// Recovered compiled webpack factory 15239. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { default: () => i.a });
  var n = r(54652),
    i = r.n(n);
}
